<template>
  <div class="page">
     <img :src="`${cdnresources}/prod/images/yueyangbao/cpsms-11.png`" />
     <img class="content-page page-item" :src="`${cdnresources}/prod/images/yueyangbao/cpsms-12.png`" />
     <img :src="`${cdnresources}/prod/images/yueyangbao/cpsms-13.png`" />
     <img class="content-pageitem" v-for="img in imgList" v-lazy="img" :key="img"/>
  </div>
</template>

<script >
import { cdnresources } from '@/util/config'
export default {
  data() {
    return {
      cdnresources,
      imgList:[
        // cdnresources+'/prod/images/yueyangbao/cpsms-12.png',
        // cdnresources+'/prod/images/yueyangbao/cpsms-13.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-14.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-15.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-16.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-17.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-018-01.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-018-02.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-018-03.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-019.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-020.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-21.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-22.png',
      ]
    }
  },
  
}
</script>

<style lang="scss" scoped>
   img{
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
  .page {
    background: #FFFFFF;
    .content-page {
       padding: 0px 10px;
       margin-top: 10px;
    }
    .content-pageitem {
      padding: 0px 10px;
    }
    .page-item {
      margin-bottom: 10px;
    }
  }
</style>